module.exports = __webpack_public_path__ + "img/example3.a990adfc.jpg";